export const formatNumber = (num: number, decimals: number): string => {
  if (isNaN(num)) {
    return '';
  }

  const formatted = num.toFixed(Math.min(4, decimals));

  return formatted.replace(/\.?0+$/, '');
};

export const getValidNumber = (
  input: number | null | undefined,
): {
  isValid: boolean;
  value: number | null;
} => {
  if (input === null || input === undefined || typeof input !== 'number' || !isFinite(input) || Number.isNaN(input)) {
    return {
      isValid: false,
      value: null,
    };
  }

  return {
    isValid: true,
    value: input,
  };
};
